<div class="bg-white dark:bg-slate-800 w-full mx-auto p-8 rounded-xl">
    <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
        <mat-icon matIconPrefix [svgIcon]="'tabler_outline:mail'"></mat-icon>
        <mat-label>Email address</mat-label>
        <input type="email" matInput lowercaseEmail [formControl]="registerForm.controls.emailAddress"
            placeholder="Type your email address">
        <mat-error
            *ngIf="registerForm.controls.emailAddress.touched && registerForm.controls.emailAddress?.errors?.invalidEmail">Invalid email address</mat-error>
    </mat-form-field>

    <mat-form-field [subscriptSizing]="'dynamic'" class="w-full mt-4">
        <mat-icon matIconPrefix [svgIcon]="'tabler_outline:mail'"></mat-icon>
        <mat-label>Repeat email address</mat-label>
        <input type="email" matInput lowercaseEmail [formControl]="registerForm.controls.emailAddressRepeat"
            placeholder="Repeat email address">
        <mat-error *ngIf="registerForm.hasError('matchFields')">Reapeted email address is not same.</mat-error>
    </mat-form-field>

    <mat-form-field [subscriptSizing]="'dynamic'" class="w-full mt-4">
        <mat-icon matIconPrefix [svgIcon]="'tabler_outline:lock'"></mat-icon>
        <mat-label>Password</mat-label>
        <input [type]="showPassword ? 'text' : 'password'" matInput [formControl]="registerForm.controls.password"
            placeholder="Set up your password">
        <button mat-icon-button matSuffix (click)="showPassword = !showPassword">
            <mat-icon [svgIcon]="showPassword ? 'tabler_outline:eye-off' : 'tabler_outline:eye'"></mat-icon>
        </button>
        <mat-error  *ngIf="registerForm.controls.password.touched && registerForm.controls.password.errors?.['minlength']">Password must be at least 8 characters long</mat-error>
    </mat-form-field>

    <div class="my-2">
        <mat-checkbox color="primary" [formControl]="registerForm.controls.rules">I accept <a
                href="https://markoutpro.com/rules" target="_blank">rules</a> and <a href="https://markoutpro.com/privacy-policy" target="_blank">privacy policy</a>.</mat-checkbox>
        <p class="text-red-600 text-sm" *ngIf="registerForm.controls.rules.touched && registerForm.controls.rules?.errors?.required">Acceptation is required.</p>
    </div>


    <button  mat-flat-button color="primary" [disabled]="isProcessing" class="w-full mt-4 mx-auto" (click)="register()">
        
        <mat-icon class="icn-spinner mr-2" *ngIf="isProcessing == true" [svgIcon]="'tabler_outline:loader'"></mat-icon>
        <span class="ml-2" *ngIf="isProcessing == true">Creating account</span>
        <span *ngIf="isProcessing == false" class="ml-2">Create account</span>
    </button>

</div>